<div class="poll-block show">
    <div class="field-title">
        {{ schema.title }}
    </div>
    <div *ngIf="schema.description" class="field-description">
        {{ schema.description }}
    </div>
    <textarea cdkTextareaAutosize [formControl]="control"  [name]="name"  [attr.required]="schema.required || false" placeholder="Развернутый ответ"></textarea>
</div>